import { useContext } from 'react';
import { AuthContext } from './AuthProvider.js';
import type { AuthContextValue } from './AuthProvider.js';

/** The auth context, or a clear failure rather than a null dereference later. */
export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (value === null) {
    throw new Error('useAuth was called outside AuthProvider.');
  }
  return value;
}

/**
 * The API client for the current company.
 *
 * Throws when there is none. Every caller sits behind the protected-route
 * boundary, so a missing client is a routing bug rather than a state a page
 * should be written to handle -- and a page that handles it renders an empty
 * table instead of saying anything useful.
 */
export function useApi(): NonNullable<AuthContextValue['api']> {
  const { api } = useAuth();
  if (api === null) {
    throw new Error('useApi was called without a company access token.');
  }
  return api;
}
